export const CLINICAL_ALERT_SAMPLE = 'O paciente encontra-se no pós-operatório de cirurgia em membro inferior esquerdo (região femoral).'
export const CLINICAL_ALERT_LIMIT = CLINICAL_ALERT_SAMPLE.length

export const STATUS_LABELS = {
  internado: 'Internado',
  estavel: 'Estável',
  observacao: 'Observação',
  ambulatorial: 'Ambulatorial',
  alta: 'Alta'
}

export const ROOM_CATEGORIES = [
  'UTI Adulto',
  'UTI Neonatal',
  'Apartamento Privativo',
  'Enfermaria',
  'Ambulatório Geral'
]

export const CHARGE_CATEGORIES = [
  { value: 'diaria', label: 'Diária / Leito' },
  { value: 'procedimento', label: 'Procedimento cirúrgico' },
  { value: 'consulta', label: 'Consulta médica' },
  { value: 'exame', label: 'Exames' },
  { value: 'medicamento', label: 'Medicamentos e materiais' },
  { value: 'taxa_sala', label: 'Taxa de sala cirúrgica' }
]

export const PAYMENT_METHODS = [
  { value: 'convenio', label: 'Convênio Faturado' },
  { value: 'cartao', label: 'Cartão de Crédito' },
  { value: 'pix', label: 'PIX Instantâneo' },
  { value: 'transferencia', label: 'Transferência Bancária' },
  { value: 'boleto', label: 'Boleto Bancário' },
  { value: 'dinheiro', label: 'Dinheiro em Espécie' }
]

export const CHARGE_CATEGORY_API = {
  'Diária / Leito': 'diaria',
  'Procedimento Cirúrgico': 'procedimento',
  'Consulta Médica': 'consulta',
  'Exames Laboratoriais': 'exame',
  'Medicamentos & Materiais': 'medicamento',
  'Taxa Sala Cirúrgica': 'taxa_sala'
}

export const PAYMENT_METHOD_API = {
  'Convênio Faturado': 'convenio',
  'Cartão de Crédito': 'cartao',
  'PIX Instantâneo': 'pix',
  'Transferência Bancária': 'transferencia',
  'Boleto Bancário': 'boleto',
  'Dinheiro em Espécie': 'dinheiro'
}

export const CHARGE_STATUSES = [
  { value: 'pendente', label: 'Pendente' },
  { value: 'pago', label: 'Pago' },
  { value: 'em_auditoria', label: 'Em auditoria' }
]

export const MEDICATION_STATUSES = [
  { value: 'pendente', label: 'Pendente' },
  { value: 'administrado', label: 'Administrado' },
  { value: 'atrasado', label: 'Atrasado' },
  { value: 'suspenso', label: 'Suspenso' }
]

export const CLINICAL_ROLES = ['Médico', 'Enfermeiro', 'Técnico de enfermagem', 'Fisioterapeuta', 'Nutricionista']

export function labelOf(list, value) {
  return list.find((item) => item.value === value)?.label || value || '—'
}

export function ageFromBirth(value) {
  if (!value) return null
  const birth = new Date(`${String(value).slice(0, 10)}T00:00:00`)
  if (Number.isNaN(birth.getTime())) return null
  const now = new Date()
  let age = now.getFullYear() - birth.getFullYear()
  const month = now.getMonth() - birth.getMonth()
  if (month < 0 || (month === 0 && now.getDate() < birth.getDate())) age -= 1
  return age >= 0 ? age : null
}

export function genderLabel(value) {
  const labels = { feminino: 'Feminino', masculino: 'Masculino', outro: 'Outro' }
  return labels[value] || value || '—'
}

export function formatDay(value) {
  if (!value) return '—'
  const day = String(value).slice(0, 10)
  const [year, month, date] = day.split('-')
  if (!date || !month || !year) return day
  return `${date}/${month}/${year}`
}

export function formatDateTime(value) {
  if (!value) return '—'
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return String(value)
  return date.toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' })
}

export function formatMoney(value) {
  return Number(value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
}

function saoPauloParts(options) {
  return Object.fromEntries(new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Sao_Paulo',
    ...options
  }).formatToParts(new Date()).map((part) => [part.type, part.value]))
}

export function todayInput() {
  const parts = saoPauloParts({ year: 'numeric', month: '2-digit', day: '2-digit' })
  return `${parts.year}-${parts.month}-${parts.day}`
}

export function nowTimeInput() {
  const parts = saoPauloParts({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
  return `${parts.hour}:${parts.minute}`
}
